var _rect, _mask, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 129,
    fill: "none",
    viewBox: "0 0 129 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 129,
    fill: "url(#paint0_linear)",
    rx: 64.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "jhinurtdga",
    width: 129,
    height: 129,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 129,
    fill: "url(#paint1_linear)",
    rx: 64.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FDFEFE",
    mask: "url(#jhinurtdga)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.441 123.547c0-1.646.668-3.223 1.857-4.387 1.189-1.163 2.802-1.817 4.483-1.817h12.679c1.682 0 3.294-.653 4.483-1.817 1.189-1.163 1.857-2.741 1.857-4.387 0-1.645-.668-3.223-1.857-4.386-1.189-1.164-2.801-1.817-4.483-1.817H67.422c-1.682 0-3.294-.654-4.483-1.817-1.19-1.164-1.857-2.742-1.857-4.387 0-1.645.668-3.223 1.857-4.387 1.189-1.163 2.801-1.817 4.483-1.817h12.68c1.68 0 3.293-.653 4.482-1.817 1.19-1.163 1.857-2.741 1.857-4.386 0-1.646-.668-3.224-1.857-4.387-1.189-1.164-2.801-1.817-4.483-1.817H42.063c-1.682 0-3.294-.654-4.483-1.817-1.19-1.164-1.857-2.742-1.857-4.387 0-1.645.668-3.223 1.857-4.387 1.189-1.163 2.801-1.817 4.483-1.817h12.68c1.68 0 3.293-.653 4.482-1.817 1.189-1.163 1.857-2.741 1.857-4.386 0-1.646-.668-3.224-1.857-4.387-1.189-1.163-2.801-1.817-4.483-1.817H16.704c-1.682 0-3.295-.654-4.483-1.817-1.19-1.164-1.857-2.741-1.857-4.387 0-1.645.668-3.223 1.857-4.387 1.188-1.163 2.801-1.817 4.482-1.817h12.68c1.681 0 3.294-.653 4.483-1.817 1.189-1.163 1.857-2.741 1.857-4.386 0-1.646-.668-3.224-1.857-4.387-1.189-1.163-2.802-1.817-4.483-1.817H5.292C-.927 42.4-3.432 55.834-1.913 69.125c1.519 13.29 6.995 25.852 15.748 36.123 8.754 10.27 20.398 17.798 33.487 21.647 13.088 3.849 27.044 3.849 40.133.002-.659-.999-1.01-2.161-1.014-3.35z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M117.273 26.973c-2.582-3.95-5.877-7.001-9.304-10.175-.415-.385-.832-.772-1.25-1.162l-55.58-.432c-1.588 0-3.111.63-4.234 1.754-1.124 1.123-1.755 2.646-1.755 4.235 0 1.588.631 3.112 1.755 4.235 1.123 1.123 2.646 1.754 4.235 1.754l66.133.182v-.391zm5.737 36.145c-1.588 0-3.111.63-4.235 1.754-1.123 1.123-1.754 2.647-1.754 4.235 0 1.588.631 3.112 1.754 4.235 1.124 1.123 2.647 1.754 4.235 1.754l5.208-.041c.726-3.952.79-7.92.782-11.937h-5.99zm-2.467-25.081c1.029-.73 1.808-1.76 2.228-2.949 2.342 5.13 4.071 10.517 5.151 16.051H87.075c-1.588 0-3.112-.63-4.235-1.754-1.123-1.123-1.754-2.647-1.754-4.235 0-1.588.63-3.112 1.754-4.235 1.123-1.123 2.647-1.754 4.235-1.754h29.946c1.262-.002 2.492-.395 3.522-1.124z",
    clipRule: "evenodd",
    opacity: 0.47
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFEFE",
    d: "M35.126 66.714c-1.501-1.512-1.501-3.963 0-5.475 1.502-1.511 3.936-1.511 5.438 0l15.442 15.548 32.43-32.653c1.501-1.512 3.936-1.512 5.438 0 1.502 1.512 1.502 3.963 0 5.475L58.952 84.77c-1.629 1.64-4.269 1.64-5.897 0L35.126 66.715z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 129,
    x2: 136.29,
    y1: 0,
    y2: 120.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C16A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 88.824,
    x2: 15.001,
    y1: 130.03,
    y2: 114.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C16A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerified);
export default __webpack_public_path__ + "static/media/email-verified.25b51211763af8e211c481ab60d2f126.svg";
export { ForwardRef as ReactComponent };